/**
 * The Google analytics DataLayer event types
 */
export enum DataLayerEventTypes {
   DATALAYER_VIRTUAL_PAGE_VIEW = 'VirtualPageview',
   DATALAYER_GA_EVENT = 'GAEvent',
}

/**
 * GA event categories
 */
export enum DataLayerEventCategories {
   DOWNLOAD = 'download',
   SAVE = 'save',
   DELETE = 'delete',
   AUTH = 'auth',
   LOGOUT = 'logout',
}

/**
 * GA event actions
 */
export enum DataLayerEventActions {
   CLICK = 'click',
}

/**
 * VirtualPageView event object interface
 */
export interface VirtualPageView {
   event: DataLayerEventTypes.DATALAYER_VIRTUAL_PAGE_VIEW;
   virtualPageURL: string;
   virtualPageTitle: string;
}

/**
 * GaEvent event object interface
 */
export interface GaEvent {
   event: DataLayerEventTypes.DATALAYER_GA_EVENT;
   eventCategory: string;
   eventAction: string;
   eventLabel: string;
   eventValue: string | number;
}
